import { DefaultFilterHandler } from './default-filter-handler.js';
function createFilterService() {
    let handler = new DefaultFilterHandler();
    const isConfigured = () => {
        return handler.isConfigured();
    };
    const load = (filterId) => {
        return handler.load(filterId);
    };
    const remove = (filterId, recordId) => {
        return handler.remove(filterId, recordId);
    };
    const save = (filterId, filter) => {
        return handler.save(filterId, filter);
    };
    const setFilterHandler = (filterHandler) => {
        handler = filterHandler;
    };
    return {
        isConfigured,
        load,
        remove,
        save,
        setFilterHandler,
    };
}
const FilterService = createFilterService();
export { FilterService, };
//# sourceMappingURL=filter-service.js.map